export default {
  fooTable(){
    $(function () {
      $(".footable-filtering-search").remove();
      $(".table").footable({
        "sorting": {
          "enabled": true
        },
        "breakpoints": {
          "x-small": 480,
          "small": 768,
          "medium": 992,
          "large": 1330,
          "x-large": 1400
        },

        "filtering": {
          "enabled": true,
          "container": "#filter-form-container",
          "placeholder": "Recherche par client",
        },

        "expandFirst": false,
        "paging": {
          "enabled": true,
          "position": "center",
          "size": 20,
          //"container": "#paging-form-container"
        },
      });
    });
  }
}


// WEBPACK FOOTER //
// ./assets/js/footable.js